export function admin(state = {}, action) {
  switch (action.type) {
    case 'ORGANIZATIONS_GET_RESPONSE':
      return {
        ...state,
        organizations: action.payload.organizations,
      };
    default:
      return state;
  }
}

export function syncStatus(state = {}, action) {
  switch (action.type) {
    case 'SYNC_GET_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'SYNC_GET_RESPONSE':
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    default:
      return state;
  }
}

export function app(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}

export function default_options(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}

export function goals(state = [], action) {
  switch (action.type) {
    default:
      return state;
  }
}

export function organization(state = {}, action) {
  switch (action.type) {
    case 'UPDATE_RECOMMENDATION_SETTINGS_RESPONSE':
      return {
        ...state,
        recommendation_settings: state.recommendation_settings.map(recommendation_setting => {
          const recommendation_setting_id = recommendation_setting.id.toString();
          if (action.payload[recommendation_setting_id]) {
            return { ...recommendation_setting, data: action.payload[recommendation_setting_id] };
          }
          return recommendation_setting;
        }),
      };
    case 'UPDATE_RECOMMENDATION_NOTIFICATION_SETTINGS_RESPONSE':
      return {
        ...state,
        recommendation_notification_settings: {
          ...state.recommendation_notification_settings,
          ...action.payload,
        },
      };
    case 'GET_SALESFORCE_USERS_RESPONSE':
      return {
        ...state,
        salesforce_users: action.payload.salesforce_users,
      };
    case 'GET_RECOMMENDATION_SETTINGS_RESPONSE':
      return {
        ...state,
        recommendation_settings: action.payload.recommendation_settings,
        any_salesforce_users_imported: action.payload.any_salesforce_users_imported,
      };
    case 'GET_RECOMMENDATION_NOTIFICATION_SETTINGS_RESPONSE':
      return {
        ...state,
        recommendation_notification_settings: action.payload.recommendation_notification_settings,
      };
    case 'RECOMMENDATION_TOGGLE_ACTIVE_RESPONSE':
      return {
        ...state,
        recommendation_settings: {
          ...state.recommendation_settings,
          [action.payload.recommendationKlassName]: state.recommendation_settings[
            action.payload.recommendationKlassName
          ].map(s => {
            if (s.key === 'active') return { ...s, value: action.payload.value };
            return s;
          }),
        },
      };
    case 'UPDATE_SALESFORCE_USER_TAGS_RESPONSE':
    case 'UPDATE_SALESFORCE_USER_LINKS_RESPONSE':
      return {
        ...state,
        salesforce_users: state.salesforce_users.map(user => ({ ...user, ...action.payload[user.salesforce_id] })),
      };
    case 'UPDATE_ORGANIZATION_REQUEST':
    case 'UPDATE_ORGANIZATION_RESPONSE':
    case 'UPDATE_ORGANIZATION_ERROR':
    case 'UPDATE_SUBSCRIPTION_DETAILS_SUCCESS':
      return { ...state, ...action.payload.organization };
    default:
      return state;
  }
}

export function view(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
